var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"usageWrap",staticClass:"usage-wrap"},[[_vm._t("default")],_c('div',{ref:"barChart",staticStyle:{"height":"126px"},attrs:{"id":"barChart"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }